import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import QtyInput from '../../Shared/QtyInput'
import NumberFormat from 'react-number-format'
import measurementTypes from '../../../_constants/measurementTypes'
import ConvertQuantity from '../../Shared/ConvertQuantity'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

export default ({ touched, errors, setFieldValue, values, isEdit }) => (
  <>
    <div className="row display-flex">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <fieldset className="fieldset">
          <legend>مواد اولیه</legend>

          <table className="table validator-table">
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">مواد اولیه</th>
                <th className="text-center">موجودی انبار</th>
                <th className="text-center">مقدار مورد نیاز</th>
                {/* <th className="text-center">مقدار مورد نیاز (واحد فرعی)</th> */}
                {/* <th className="text-center">واحد فرعی</th> */}
              </tr>
            </thead>
            <tbody>
              {values.items &&
                values.items.map((item, index) => (
                  <tr key={'p-' + index}>
                    <td>{index + 1}</td>
                    <td>
                      {values.items[index].product &&
                        values.items[index].product.category.name}
                    </td>
                    <td>
                      {values.items[index].product &&
                        values.items[index].product.brand.name}
                    </td>
                    <td>
                      {values.items[index].product &&
                        values.items[index].product.name}
                    </td>
                    <td>
                      {values.items[index].product && (
                        <MeasurementTypeDoubleBox
                          product={values.items[index].product}
                          value={values.items[index].unitProductQuantity}
                          // onlySub={values.items[index].product.subMeasurementType !== undefined ? true : false}
                        />
                      )}

                      {/* <div className="flex-col flex-center">
                    <span style={{ marginBottom: 10 }}>
                      {values.items[index].unitProductQuantity} {values.items[index].product ? '(' + measurementTypes.filter(el => el.value === values.items[index].product.measurementType)[0].label + ')' : ''}
                    </span>
                    {values.items[index].product && values.items[index].product.conversionUnit ?
                      <span>
                        {(Number((values.items[index].unitProductQuantity / values.items[index].product.conversionUnit).toFixed(3)) + (values.items[index].product.subMeasurementType !== undefined
                          ? ' (' + measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0].label + ')'
                          : ''))}
                      </span>
                      : ''}
                  </div> */}
                    </td>
                    <td>
                      <div>
                        <QtyInput
                          disabled={
                            values.items[index].product
                              ? values.items[index].product.conversionUnit
                              : false
                          }
                          className="text-input"
                          measurementType={
                            values.items[index].product
                              ? values.items[index].product.measurementType
                              : undefined
                          }
                          subMeasurementType={
                            values.items[index].product
                              ? values.items[index].product.subMeasurementType
                              : undefined
                          }
                          conversionUnit={
                            values.items[index].product
                              ? values.items[index].product.conversionUnit
                              : undefined
                          }
                          onChange={(val, subVal) => {
                            if (
                              val <= values.items[index].unitProductQuantity
                            ) {
                              setFieldValue(
                                `items[${index}][subQuantity]`,
                                subVal
                              )
                              setFieldValue(`items[${index}][quantity]`, val)
                            } else {
                              setFieldValue(`items[${index}][subQuantity]`, 0)
                              setFieldValue(`items[${index}][quantity]`, 0)
                            }
                          }}
                          // max={values.items[index].quantity}
                          defualtValue={values.items[index].quantity}
                          defualtSubValue={values.items[index].subQuantity}
                        />
                        <ErrorMessage
                          component={ErrorPopUp}
                          name={`items[${index}].quantity`}
                          style={{ margin: '0 auto' }}
                        />
                      </div>
                      {/* {JSON.stringify(values.items[index])} */}
                    </td>
                    {/* <td>
                  {values.items[index].product && values.items[index].product.subMeasurementType != undefined && measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0] ? '(' + measurementTypes.filter(el => el.value === values.items[index].product.subMeasurementType)[0].label + ')' : ''}
                </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </fieldset>
      </div>
    </div>

    {values.lastDescription && !isEdit ? (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>توضیحات مسئول برنامه‌ریزی تولید</legend>
            <pre className="pre">{values.lastDescription}</pre>
          </fieldset>
        </div>
      </div>
    ) : (
      ''
    )}
  </>
)
